import React, { Component } from 'react'
import './style.css'
import List from '../../../components/List'
import Dropdown from '../../../components/Dropdown'

import queryString from 'query-params'

class UsersList extends Component {

  state = {
    filter: 'all'
  }

  render() {

    const { filter } = this.state

    const users = filter && filter !== "all" ? this.props.users.filter(({ tutors, clients }) => {
      const state = tutors.length ? tutors[0] && tutors[0].state : clients[0] && clients[0].state
      return state === filter
    }) : this.props.users

    return <React.Fragment>
      <List
        header={
          <React.Fragment>
                <Dropdown
                  label={<span><i className="fas fa-filter"></i> {filter}</span>} 
                  options={[{
                    label: "All",
                    value: "all"
                  }, {
                    label: "Validated",
                    value: "validated"
                  },{
                    label: "Completed",
                    value: "completed"
                  },{
                    label: "In progress",
                    value: "in-progress"
                  },{
                    label: "Blocked",
                    value: "blocked"
                  },{
                    label: "Disabled",
                    value: "disabled"
                  }]}
                  onSelect={filter => this.setState({ filter })}
                  />
                  <span>{users.length}</span>
                </React.Fragment>
        } 
        list={users.map(({ _id, first_name, last_name, email, phone_number, role, tutors, clients }) => ({
          link: `/users/${role}/${_id}`,
            active: _id === this.props.active,
            title: <div>{first_name} {last_name}</div> ,
            body: <div>{email} <br /> {phone_number} </div>,
            footer: <small className={'state ' + (tutors.length ? tutors[0] && tutors[0].state : clients[0] && clients[0].state)}>{tutors.length ? tutors[0] && tutors[0].state : clients[0] && clients[0].state}</small>
          }))}
        />
    </React.Fragment>
  }
}

export default UsersList;



// WEBPACK FOOTER //
// ./src/containers/users/List/index.js